//  frontend/src/utils/statusEnum.js
// payment/enrollment status enumeration
const statusEnum = Object.freeze({
  PENDING_PAYMENT: "pending-payment",
  PAYMENT_COMPLETED: "payment-completed",
  ACTIVE: "active"

});

export default statusEnum;